import { render, staticRenderFns } from "./ViewOblivion.vue?vue&type=template&id=f72c3ece&"
import script from "./ViewOblivion.vue?vue&type=script&lang=js&"
export * from "./ViewOblivion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports